import { render, staticRenderFns } from "./ExceptionWithImg.vue?vue&type=template&id=4ce2bae6&scoped=true&"
import script from "./ExceptionWithImg.vue?vue&type=script&lang=js&"
export * from "./ExceptionWithImg.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionWithImg.vue?vue&type=style&index=0&id=4ce2bae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce2bae6",
  null
  
)

export default component.exports